module.exports = __webpack_public_path__ + "static/img/smbc.b6d093ec.svg";